import React from 'react';
import InputRange from 'react-input-range';
import isNil from 'lodash/isNil';
import InputField from 'components/pure/utils/form/InputField';
import './RangeField.styl';

export default class RangeField extends React.Component {
  constructor(props) {
    super(props);

    this.onEndChange = this.onEndChange.bind(this);
    this.onStartChange = this.onStartChange.bind(this);
    this.onStartBlur = this.onStartBlur.bind(this);
    this.onEndBlur = this.onEndBlur.bind(this);
    this.onInputRangeValuesChange = this.onInputRangeValuesChange.bind(this);
  }

  onInputRangeValuesChange(values) {
    const {min, max} = values;
    this.props.onValueChange({start: min, end: max});
  }

  onStartChange(value) {
    const {end} = this.props;
    this.props.onValueChange({
      start: value,
      end,
    });
  }

  onStartBlur() {
    // only adjust the ranges after the user is done typing
    const {start, end} = this.props;
    if (start > end) {
      this.props.onValueChange({
        start,
        end: start,
      });
    }
  }

  onEndChange(value) {
    const {start} = this.props;
    this.props.onValueChange({
      start,
      end: value,
    });
  }

  onEndBlur() {
    // only adjust the ranges after the user is done typing
    const {start, end} = this.props;
    if (end < start) {
      this.props.onValueChange({
        start: end,
        end,
      });
    }
  }

  render() {
    const {
      start,
      end,
      formatLabel = _ => null,
      prefix,
      suffix,
      separator = 'to',
      showInputRange = true,
      disabled,
      range = {start: 0, end: 100},
    } = this.props;

    // don't let the slider's start value go past the sliders end value
    //  and vice versa
    const startValue = isNaN(start) ? 0 : start;
    const endValue = isNaN(end) ? 100 : end;

    const minValue = startValue > endValue ? Math.max(startValue, endValue) : startValue;
    const maxValue = endValue < startValue ? Math.max(startValue, endValue) : endValue;

    return (
      <div className="range-field input-range-field">
        {showInputRange && (
          <InputRange
            minValue={range.start}
            maxValue={range.end}
            formatLabel={formatLabel}
            value={{min: minValue, max: maxValue}}
            onChange={this.onInputRangeValuesChange}
          />
        )}
        <div className="input-range-boxes">
          {prefix && <div className="prefix">{prefix}</div>}
          <InputField
            type="number"
            autoFocus={this.props.autoFocus}
            placeholder={this.props.placeholder}
            value={isNil(start) ? '' : start}
            min={range.start}
            max={range.end}
            onChange={this.onStartChange}
            disabled={disabled}
            onBlur={this.onStartBlur}
          />
          <div className="separator">{separator}</div>
          <InputField
            type="number"
            placeholder={this.props.placeholder}
            value={isNil(end) ? '' : end}
            min={range.start}
            max={range.end}
            onChange={this.onEndChange}
            disabled={disabled}
            onBlur={this.onEndBlur}
          />
          {suffix && <div className="suffix">{suffix}</div>}
        </div>
      </div>
    );
  }
}
